import isPropValid from '@emotion/is-prop-valid';
import React, { createElement, FunctionComponent, ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { StyleSheetManager } from 'styled-components';
import { extractDataFromElement } from './data';

// Restores the styled-components v5 default: filter non-HTML props from DOM
// elements, forward everything to React components. v6 forwards all props
// unless they are $-prefixed, which would leak our styling props to the DOM.
const shouldForwardProp = (propName: string, target: unknown) =>
  typeof target === 'string' ? isPropValid(propName) : true;

const render = <T>(querySelector: string, Component: FunctionComponent<T>, dataProps?: boolean) => {
  const elementList = document.querySelectorAll(querySelector);
  elementList.forEach((elem) => {
    const props = dataProps ? extractDataFromElement<T>(elem, 'data-props') : undefined;
    if (props || !dataProps) {
      const root = createRoot(elem);
      root.render(
        createElement(
          StyleSheetManager,
          { shouldForwardProp },
          createElement(
            Component as FunctionComponent<{}>,
            props as React.Attributes,
            elem.childNodes as ReactNode
          )
        )
      );
    }
  });
};

export default render;
